import React from 'react';

import { TextInput, SelectDropdown } from '../../../components/reusables/FormElements';

import { IJobPostFormData, TJobPostFormField } from '../../../interfaces/job_posts';
import { ISelectDropdownOption } from '../../../interfaces/formElements';

import { OPBooleanOptions } from '../../../data/options';

interface IJobDetailsFormProps {
    formData: IJobPostFormData;
    setFormData: React.Dispatch<React.SetStateAction<IJobPostFormData>>;
    isFormDisabled: boolean;
}

const JobApplicationDetailsForm = (props: IJobDetailsFormProps) => {
    const { formData, setFormData, isFormDisabled } = props;

    const onChangeText = (name: TJobPostFormField, value: string) => {
        setFormData({
            ...formData,
            [name]: { value, error: "" }
        });
    };

    const onChangeSelect = (name: TJobPostFormField, option: ISelectDropdownOption) => {
        setFormData(prevData => {
            return {
                ...prevData,
                [name]: { value: option, error: "" }
            };
        });
    };

    return (
        <div className='immployer__details_form_view'>
            <div className="immployer__details_form_inputs__container">
                <div className="immployer__details_form_inputs">
                    <span>
                        Applications will be sent to the email address that you provide. We strongly suggest this as it will allow the candidates to apply to the job with one click in our platform and allow us to provide you accurate job analytics.
                    </span>
                    <TextInput
                        name="contact_title"
                        type="text"
                        label="Contact Title"
                        placeholder='eg. Marketing Manager'
                        errorMsg={formData.contact_title.error}
                        onChange={(value: string) => onChangeText("contact_title", value)}
                        value={formData.contact_title.value}
                        read_only={isFormDisabled}
                    />
                    <TextInput
                        name="contact_email"
                        type="email"
                        label="Contact Email"
                        placeholder='eg. marketing@example.com'
                        errorMsg={formData.contact_email.error}
                        onChange={(value: string) => onChangeText("contact_email", value)}
                        value={formData.contact_email.value}
                        read_only={isFormDisabled}
                    />
                    <SelectDropdown
                        name="require_cover_letter"
                        label="Require Cover Letter"
                        options={OPBooleanOptions}
                        onChange={(option: ISelectDropdownOption) => onChangeSelect("require_cover_letter", option)}
                        value={formData.require_cover_letter.value}
                        read_only={isFormDisabled}
                    />
                    <span>
                        Alternatively you can enter a web link for applicants to apply externally. If a contact email and web link are both provided, then the contact email field will take priority.
                    </span>
                    <TextInput
                        name="web_link"
                        type="text"
                        label="External Apply URL"
                        placeholder='eg. https://example.com/apply'
                        errorMsg={formData.web_link.error}
                        onChange={(value: string) => onChangeText("web_link", value)}
                        value={formData.web_link.value}
                        length_flex={2}
                        read_only={isFormDisabled}
                    />
                </div>
            </div>
        </div>
    )
}

export default JobApplicationDetailsForm;